import Axios from "../config/config";

//QUIZ  APIS

export const ADD_QUIZ_SETTIING = async (body) => {
    try {
        const response = await Axios.post('add-quiz-setting/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const EDIT_QUIZ_SETTIING = async (body) => {
    try {
        const response = await Axios.post('edit-quiz-setting/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const VIEW_QUIZ_SETTIING = async (body) => {
    try {
        const response = await Axios.post('view-quiz-setting/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const VIEW_QUIZ_QUESTION = async (body) => {
    try {
        const response = await Axios.post('view-quiz-question/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const ADD_QUIZ_QUESTION = async (body) => {
    try {
        const response = await Axios.post('add-quiz-question/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const EDIT_QUIZ_QUESTION = async (body) => {
    try {
        const response = await Axios.post('edit-quiz-question/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const List_QUIZ_QUESTION = async (body) => {
    try {
        const response = await Axios.post('list-quiz-question/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const DELETE_QUIZ_QUESTION = async (body) => {
    try {
        const response = await Axios.post('delete-quiz-question/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const BULD_IMPORT_QUIZ_QUESTION_TEMPLATE = async (body) => {
  try {
    const response = await Axios.post( 'bulk-import-quiz-question-template/',body,
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const BULK_QUIZ_QUESTION = async (body) => {
    try {
        const response = await Axios.post('bulk-add-quiz-questions/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const UPDATE_QUIZE_SETTING_DATA = async (body) => {
    try {
        const response = await Axios.post('update-video-prog/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};
